export default __webpack_public_path__ + "static/media/Poppins-SemiBold.5981b450.ttf";